
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import LogoutIcon from '@mui/icons-material/Logout';
import RocketLaunch from '@mui/icons-material/RocketLaunch';
import PaymentIcon from '@mui/icons-material/Payment';
import {
    Button, Divider, Grid, ListItemIcon, Menu, MenuItem, AppBar, ListItem, Toolbar,
    ListItemAvatar,
    Avatar, ListItemText
} from '@mui/material';
import React from 'react';
import { Link, useNavigate } from "react-router-dom";

import { api } from '../utils';
import MatSidebar from './matSidebar';


const MatLayout = ({ children }) => {

    const [user, setUser] = React.useState({})
    React.useEffect(() => {
        api.get('/api/v1/user-detail').then(r => {
            // setLoading(false)
            //todo
            setUser(r.data)
        })
    }, [])
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [scrolled, setScroll] = React.useState(true);
    React.useEffect(() => {
        const handleScroll = event => {
            setScroll(window.scrollY < 2);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    return (
        <Grid sx={{ mx: { xs: 1, sm: 3 } }}>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}

                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            >
                <MenuItem component={Link} to="/support/edit-profile">
                    <ListItemIcon>
                        <AccountCircleIcon />
                    </ListItemIcon>
                    ویرایش حساب کاربری
                </MenuItem>
                <MenuItem component={Link} to="/support/my-payments">
                    <ListItemIcon>
                        <PaymentIcon />
                    </ListItemIcon>
                    پرداخت های من
                </MenuItem>
                <MenuItem component={Link} to="/support/my-plans">
                    <ListItemIcon>
                        <RocketLaunch />
                    </ListItemIcon>
                    پلن های من
                </MenuItem>
                {/* <Divider /> */}
                {/* <MenuItem component={Link} to="/accounts/logout">
                    <ListItemIcon>
                        <LogoutIcon fontSize="medium" />
                    </ListItemIcon>
                    خروج
                </MenuItem> */}
            </Menu>

            <AppBar sx={{
                textAlign: 'right', boxShadow: scrolled && 'none !important', backgroundColor: scrolled ? '#ffffff00' : '#fff', transition: '.3s all'
            }}  >
                <Toolbar sx={{ justifyContent: "flex-end" }}>
                    <ListItem className="ltr" onClick={handleClick} sx={{ width: 'fit-content', pr: 0, fontSize: '14px', cursor: 'pointer', direction: 'rtl', textAlign: 'right', color: '#000' }}>
                        <ListItemAvatar className="ltr">
                            <Avatar >
                                <AccountCircleIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={user.full_name} secondary={'online'} />
                        {/* <Button variant="contained" color="secondary" endIcon={<KeyboardArrowDown />}
                            >
                            {}
                        </Button> */}
                    </ListItem>
                </Toolbar>
            </AppBar >
            <MatSidebar user={user} />

            <Grid mt={10} sx={{ ml: { sm: 11 } }}>
                {/* <Grid item xs={12} sm={1}  > */}
                {/* </Grid> */}
                {/* <Grid item xs={12} > */}
                {children}
                {/* </Grid> */}
                <Grid container spacing={'6px'} mt={8} pb={3} sx={{ textAlign: 'center' }} justifyContent='space-between' >
                    <Grid item xs={12} sm={'auto'} >
                        2022 © Hamyarma Digital Creative Agency
                    </Grid >
                    <Grid item xs={12} sm={'auto'} >
                        Crafted with <span style={{ color: '#ff5b5c' }}>❤</span> by HAMYARMA
                    </Grid >
                </Grid >
            </Grid>
        </Grid >
    )
}

export default MatLayout;